// src/components/Home/ActionCardsSection.tsx
import React, {useRef} from 'react';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import Button from '../Button';
import {motion, useInView} from "framer-motion";
import {useNavigate} from "react-router-dom";

interface CardProps {
    icon: React.ReactNode;
    name: string;
    img : string;
    desc1: string;
    desc2: string;
    index: number;
    genre : string;
    book: string;
    follow: string;
    like: string;

}

const ActionCard: React.FC<CardProps> = ({ icon, name, img, desc1, desc2, index, genre, book, follow, like}) => {
    // 두 번째 카드인지 확인
    const isSecondCard = index === 2;
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, margin: "-100px"});

    return (

        <motion.div
            ref={ref}
            initial={{ opacity: 0 }}
            animate={isInView ? {opacity: 1, y: 0} : {}}
            transition={{duration: 0.8, delay: 0.2 + index * 0.1,  ease: 'easeOut', }}
            className={`p-[33px] md:py-[25px] md:px-[12px] w-[420px] md:w-full md:h-[480px] gap-3 min-h-[642px] md:min-h-[480px] transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col 
    ${isSecondCard ? 'border-[#6C7B7F33]' : 'border-[#19CF7A1A]'} 
    rounded-[24px]`}
            style={{
                border: isSecondCard
                    ? '1px solid rgba(108, 123, 127, 0.20)'
                    : '1px solid rgba(25, 207, 122, 0.20)',
                background: isSecondCard
                    ? 'linear-gradient(135deg, rgba(108, 123, 127, 0.05) 0%, rgba(108, 123, 127, 0.10) 70.71%)'
                    : 'linear-gradient(135deg, rgba(25, 207, 122, 0.05) 0%, rgba(25, 207, 122, 0.10) 70.71%)',
            }}
        >


            <div className="flex flex-col md:flex-row  items-center gap-3 ">

                    <div
                        className="flex justify-center items-center w-[96px] h-[96px] md:w-[64px] md:h-[64px] rounded-full flex-shrink-0 border-[4px] border-white"
                        style={{
                            strokeWidth: 4,
                            stroke: "#FFF",
                            filter: "drop-shadow(0px 10px 15px rgba(0,0,0,0.10)) drop-shadow(0px 4px 6px rgba(0,0,0,0.10))",
                        }}
                    >
                        <img
                            className="w-full h-full rounded-full object-cover shadow-[4px_4px_10px_rgba(0,0,0,0.10)]"
                            src={img || "/img/profile_sam.jpg"}
                            alt="작가 이미지"
                        />
                    </div>

                    <div className="flex flex-col md:items-start items-center md:gap-1.5">
                        <span className="text-[20px] text-center md:text-left  md:text-base font-bold text-[#111827]">
                            {name}
                        </span>
                          <span className={`${
                            isSecondCard ? 'text-[#0B3A47]' : 'text-main'
                        } text-lg leading-[24px] md:text-base  md:leading-[20px] font-medium flex-grow`}>
                    {desc1}
                            <span className="text-base text-[#6C7B7F] md:text-sm font-normal">을 쓰고 있어요!</span>
                </span>
                    </div>
            </div>

            <div className={"flex flex-col gap-3"}>
                {/*장르 */}
                <div
                    className={"flex flex-col gap-2 bg-white p-4 rounded-[12px] w-full h-[91px] border-0 border-[#E5E74EB] "}>
                    <div className={"flex flex-row items-center  gap-2 "}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <g clip-path="url(#clip0_4962_10432)">
                                <path
                                    d="M11.5123 0.571875L9.77166 2.31562L13.6842 6.22813L15.4248 4.4875C16.1092 3.80313 16.1092 2.69688 15.4248 2.0125L13.9873 0.571875C13.3029 -0.1125 12.1967 -0.1125 11.5123 0.571875ZM8.99979 2.95625L8.71229 3.04375L4.20916 4.39375C3.58729 4.58125 3.09354 5.05625 2.88729 5.675L0.118536 13.9312C-0.000214227 14.2844 0.0872858 14.6781 0.346661 14.9438L5.14666 10.1469C5.05291 9.95 4.99979 9.73125 4.99979 9.5C4.99979 8.67188 5.67166 8 6.49979 8C7.32791 8 7.99979 8.67188 7.99979 9.5C7.99979 10.3281 7.32791 11 6.49979 11C6.26854 11 6.04979 10.9469 5.85291 10.8531L1.05291 15.6531C1.32166 15.9125 1.71229 16.0031 2.06541 15.8813L10.3248 13.1125C10.9404 12.9062 11.4185 12.4125 11.606 11.7906L12.956 7.2875L13.0435 7L8.99979 2.95625Z"
                                    fill={isSecondCard ? '#6C7B7F' : '#16B96A'}/>
                            </g>
                            <defs>
                                <clipPath id="clip0_4962_10432">
                                    <path d="M0 0H16V16H0V0Z" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <span className={"text-[#374151] text-base md:text-sm font-medium"}>주요 장르</span>

                    </div>

                    <span className={"text-[#6C7B7F] text-base  md:text-sm  font-normal"}>{genre}</span>

                </div>

                {/*대표작*/}
                <div
                    className={"flex flex-col gap-2 bg-white p-4 rounded-[12px] w-full h-[91px] border-0 border-[#E5E74EB] "}>
                    <div className={"flex flex-row items-center  gap-2"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">

                            <path
                                d="M7.8 14.7344C8.1375 14.8531 8.5 14.6062 8.5 14.25V2.45625C8.5 2.325 8.45 2.19375 8.34375 2.1125C7.73125 1.625 6.325 1 4.5 1C2.92188 1 1.44688 1.41562 0.565625 1.75312C0.2125 1.89062 0 2.24063 0 2.61875V14.1906C0 14.5625 0.4 14.8219 0.753125 14.7063C1.7375 14.3781 3.29688 14 4.5 14C5.55937 14 6.96875 14.4375 7.8 14.7344ZM10.2 14.7344C11.0312 14.4375 12.4406 14 13.5 14C14.7031 14 16.2625 14.3781 17.2469 14.7063C17.6 14.825 18 14.5625 18 14.1906V2.61875C18 2.24063 17.7875 1.89062 17.4344 1.75625C16.5531 1.41563 15.0781 1 13.5 1C11.675 1 10.2688 1.625 9.65625 2.1125C9.55313 2.19375 9.5 2.325 9.5 2.45625V14.25C9.5 14.6062 9.86562 14.8531 10.2 14.7344Z"

                                fill={isSecondCard ? '#6C7B7F' : '#16B96A'}/>
                        </svg>
                        <span className={"text-[#374151] text-base  md:text-sm  font-medium"}>대표작</span>

                    </div>

                    <span className={"text-[#6C7B7F] text-base md:text-sm  font-normal"}>{book}</span>

                </div>

                {/*작가 한마디*/}
                <div
                    className={"flex flex-col justify-center  gap-2 bg-white px-3 rounded-[12px] w-full h-[94px] border-0 border-[#E5E74EB] "}>
                    <div className={"flex flex-row items-center  gap-2"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">

                            <path
                                d="M0 6.75C0 4.67812 1.67812 3 3.75 3H4C4.55312 3 5 3.44687 5 4C5 4.55313 4.55312 5 4 5H3.75C2.78437 5 2 5.78437 2 6.75V7H4C5.10313 7 6 7.89687 6 9V11C6 12.1031 5.10313 13 4 13H2C0.896875 13 0 12.1031 0 11V10V9V6.75ZM8 6.75C8 4.67812 9.67813 3 11.75 3H12C12.5531 3 13 3.44687 13 4C13 4.55313 12.5531 5 12 5H11.75C10.7844 5 10 5.78437 10 6.75V7H12C13.1031 7 14 7.89687 14 9V11C14 12.1031 13.1031 13 12 13H10C8.89688 13 8 12.1031 8 11V10V9V6.75Z"
                                fill={isSecondCard ? '#6C7B7F' : '#16B96A'}/>
                        </svg>
                        <span className={"text-[#374151] text-base  md:text-sm  font-medium"}>작가 한마디</span>

                    </div>

                    <span className={"text-[#6C7B7F] text-sm md:text-[13px] leading-[22px] font-normal"}>"{desc2}"</span>

                </div>


                <div className={"flex flex-row justify-between "}>
                    <div className={"flex flex-row gap-4"}>
                        <div className={"flex flex-row items-center gap-1"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none">

                                <path
                                    d="M1.4875 9.38767L7.13438 14.6595C7.36875 14.8783 7.67812 15.0002 8 15.0002C8.32187 15.0002 8.63125 14.8783 8.86563 14.6595L14.5125 9.38767C15.4625 8.50329 16 7.26267 16 5.96579V5.78454C16 3.60017 14.4219 1.73767 12.2688 1.37829C10.8438 1.14079 9.39375 1.60642 8.375 2.62517L8 3.00017L7.625 2.62517C6.60625 1.60642 5.15625 1.14079 3.73125 1.37829C1.57812 1.73767 0 3.60017 0 5.78454V5.96579C0 7.26267 0.5375 8.50329 1.4875 9.38767Z"
                                    fill="#EF4444"/>
                            </svg>
                            <span className={"text-[#6C7B7F] text-base md:text-xs font-normal leading-5"}>{like}</span>

                        </div>

                        <div className={"flex flex-row items-center gap-1"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16"
                                 fill="none">
                                <g clip-path="url(#clip0_4962_10466)">
                                    <path
                                        d="M3.98438 4C3.98438 2.93913 4.4058 1.92172 5.15595 1.17157C5.90609 0.421427 6.92351 0 7.98438 0C9.04524 0 10.0627 0.421427 10.8128 1.17157C11.5629 1.92172 11.9844 2.93913 11.9844 4C11.9844 5.06087 11.5629 6.07828 10.8128 6.82843C10.0627 7.57857 9.04524 8 7.98438 8C6.92351 8 5.90609 7.57857 5.15595 6.82843C4.4058 6.07828 3.98438 5.06087 3.98438 4ZM0.984375 15.0719C0.984375 11.9937 3.47813 9.5 6.55625 9.5H9.4125C12.4906 9.5 14.9844 11.9937 14.9844 15.0719C14.9844 15.5844 14.5687 16 14.0562 16H1.9125C1.4 16 0.984375 15.5844 0.984375 15.0719ZM16.7344 9.75V7.75H14.7344C14.3188 7.75 13.9844 7.41563 13.9844 7C13.9844 6.58437 14.3188 6.25 14.7344 6.25H16.7344V4.25C16.7344 3.83437 17.0688 3.5 17.4844 3.5C17.9 3.5 18.2344 3.83437 18.2344 4.25V6.25H20.2344C20.65 6.25 20.9844 6.58437 20.9844 7C20.9844 7.41563 20.65 7.75 20.2344 7.75H18.2344V9.75C18.2344 10.1656 17.9 10.5 17.4844 10.5C17.0688 10.5 16.7344 10.1656 16.7344 9.75Z"
                                        fill={isSecondCard ? '#6C7B7F' : '#16B96A'}/>

                                </g>
                                <defs>
                                    <clipPath id="clip0_4962_10466">
                                        <path d="M0.984375 0H20.9844V16H0.984375V0Z" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span
                                className={"text-[#6C7B7F] text-base md:text-xs font-normal leading-5"}>{follow}</span>

                        </div>

                    </div>

                    <div className={`
                
                ${isSecondCard ?
                        'bg-[#6C7B7F]' :
                        'bg-main'} 
                
              w-[70px] h-[30px] text-center items-center md:text-xs flex justify-center text-white text-sm font-medium rounded-full`}>
                        팔로우
                    </div>

                </div>

            </div>


        </motion.div>
    );
};


const AuthorSection: React.FC = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, margin: "-100px"});
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    return (
        <section className=" px-3 flex flex-col gap-[34px] "
        >
            <motion.div
                ref={ref}
                className="flex flex-col gap-3 text-center"
                initial={{opacity: 0, y: 20}}
                animate={isInView ? {opacity: 1, y: 0} : {}}
                transition={{duration: 0.6, delay: 0}}
            >
                <h2 className="text-[36px] md:text-[22px] font-extrabold  text-[#111827]">
                    작가의 이야기가 머무는 자리
                </h2>

                <motion.span
                    ref={ref}
                    className="text-[20px] md:text-base text-[#6C7B7F] font-normal md:leading-[22px]"
                    initial={{opacity: 0, y: 20}}
                    animate={isInView ? {opacity: 1, y: 0} : {}}
                    transition={{duration: 0.6, delay: 0.2}}
                >
                    작가의 말 한 줄이 <br className="hidden md:block"/> 독자와의 문을 여는 시작이 됩니다.
                </motion.span>
            </motion.div>

            <div className="mx-auto flex  gap-[10px] md:flex-col ">
                <ActionCard
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none">
                            <g clipPath="url(#clip0_4962_10804)">
                                <path
                                    d="M10.5 12C12.0913 12 13.6174 11.3679 14.7426 10.2426C15.8679 9.11742 16.5 7.5913 16.5 6C16.5 4.4087 15.8679 2.88258 14.7426 1.75736C13.6174 0.632141 12.0913 0 10.5 0C8.9087 0 7.38258 0.632141 6.25736 1.75736C5.13214 2.88258 4.5 4.4087 4.5 6C4.5 7.5913 5.13214 9.11742 6.25736 10.2426C7.38258 11.3679 8.9087 12 10.5 12ZM8.35781 14.25C3.74063 14.25 0 17.9906 0 22.6078C0 23.3766 0.623438 24 1.39219 24H15.1312C14.9859 23.5875 14.9578 23.1375 15.0656 22.6969L15.7687 19.8797C15.9 19.35 16.1719 18.8719 16.5563 18.4875L18.4453 16.5984C16.9406 15.1453 14.8969 14.25 12.6375 14.25H8.35781ZM28.7719 11.0484C28.0406 10.3172 26.8547 10.3172 26.1188 11.0484L24.7406 12.4266L28.0687 15.7547L29.4469 14.3766C30.1781 13.6453 30.1781 12.4594 29.4469 11.7234L28.7719 11.0484ZM17.6203 19.5469C17.4281 19.7391 17.2922 19.9781 17.2266 20.2453L16.5234 23.0625C16.4578 23.3203 16.5328 23.5875 16.7203 23.775C16.9078 23.9625 17.175 24.0375 17.4328 23.9719L20.25 23.2687C20.5125 23.2031 20.7563 23.0672 20.9484 22.875L27.0047 16.8141L23.6766 13.4859L17.6203 19.5469Z"
                                    fill="#19CF7A"
                                    fillOpacity="0.2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_4962_10804">
                                    <path d="M0 0H30V24H0V0Z" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    }
                    name="오지안"
                    img={"/img/home/author1.jpg"}
                    desc1="소재가 신선한 글"
                    desc2={"자유에 대한 갈망과 새로운 가능성을 향한 도전을 작은 존재들의 시선으로 바라보며 작품에 담고 있어요."}
                    index={1}
                    genre={"소설"}
                    book={"「물고기의 꿈」, 「하늘을 나는 씨앗」"}
                    follow={"182"}
                    like={"232"}
                />
                <ActionCard
                    icon={<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24"
                               fill="none">
                        <g clip-path="url(#clip0_4962_10821)">
                            <path
                                d="M5.32812 0C2.84375 0 0.828125 2.01562 0.828125 4.5V19.5C0.828125 21.9844 2.84375 24 5.32812 24H18.8281H20.3281C21.1578 24 21.8281 23.3297 21.8281 22.5C21.8281 21.6703 21.1578 21 20.3281 21V18C21.1578 18 21.8281 17.3297 21.8281 16.5V1.5C21.8281 0.670312 21.1578 0 20.3281 0H18.8281H5.32812ZM5.32812 18H17.3281V21H5.32812C4.49844 21 3.82812 20.3297 3.82812 19.5C3.82812 18.6703 4.49844 18 5.32812 18ZM6.82812 6.75C6.82812 6.3375 7.16563 6 7.57812 6H16.5781C16.9906 6 17.3281 6.3375 17.3281 6.75C17.3281 7.1625 16.9906 7.5 16.5781 7.5H7.57812C7.16563 7.5 6.82812 7.1625 6.82812 6.75ZM7.57812 9H16.5781C16.9906 9 17.3281 9.3375 17.3281 9.75C17.3281 10.1625 16.9906 10.5 16.5781 10.5H7.57812C7.16563 10.5 6.82812 10.1625 6.82812 9.75C6.82812 9.3375 7.16563 9 7.57812 9Z"
                                fill="#6C7B7F"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4962_10821">
                                <path d="M0.828125 0H21.8281V24H0.828125V0Z" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>}
                    name="김시우"
                    img={"/img/home/author2.jpg"}
                    desc1="경험을 바탕으로 한 글"
                    desc2={"복잡한 마음을 단순하게, 막연한 내일을 구체적인 오늘로 바꾸는 방법을 찾아 나누고 있습니다."}
                    index={2}
                    genre={"에세이"}
                    book={"「마음의 정리법」, 「오늘을 사는 기술」"}
                    follow={"350"}
                    like={"291"}
                />

                {!isMobile && (
                    <ActionCard
                        icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24"
                                 fill="none">
                                <g clip-path="url(#clip0_4962_10838)">
                                    <path
                                        d="M0.65625 4.5C0.65625 2.84531 2.00156 1.5 3.65625 1.5H21.6562C23.3109 1.5 24.6562 2.84531 24.6562 4.5V19.5C24.6562 21.1547 23.3109 22.5 21.6562 22.5H3.65625C2.00156 22.5 0.65625 21.1547 0.65625 19.5V4.5ZM15.8344 9.49219C15.6234 9.18281 15.2766 9 14.9062 9C14.5359 9 14.1844 9.18281 13.9781 9.49219L9.9 15.4734L8.65781 13.9219C8.44219 13.6547 8.11875 13.5 7.78125 13.5C7.44375 13.5 7.11563 13.6547 6.90469 13.9219L3.90469 17.6719C3.63281 18.0094 3.58125 18.4734 3.76875 18.8625C3.95625 19.2516 4.35 19.5 4.78125 19.5H9.28125H10.7812H20.5312C20.9484 19.5 21.3328 19.2703 21.525 18.9C21.7172 18.5297 21.6937 18.0844 21.4594 17.7422L15.8344 9.49219ZM5.90625 9C6.50299 9 7.07528 8.76295 7.49724 8.34099C7.9192 7.91903 8.15625 7.34674 8.15625 6.75C8.15625 6.15326 7.9192 5.58097 7.49724 5.15901C7.07528 4.73705 6.50299 4.5 5.90625 4.5C5.30951 4.5 4.73722 4.73705 4.31526 5.15901C3.8933 5.58097 3.65625 6.15326 3.65625 6.75C3.65625 7.34674 3.8933 7.91903 4.31526 8.34099C4.73722 8.76295 5.30951 9 5.90625 9Z"
                                        fill="#16B96A"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_4962_10838">
                                        <path d="M0.65625 0H24.6562V24H0.65625V0Z" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        }
                        name="박민준"
                        img={"/img/home/author3.jpg"}
                        desc1="감수성이 돋보이는 글"
                        desc2={"타이핑으로만 소통하는 시대에 손글씨가 주는 특별한 감동과 힘을 많은 사람들과 나누고 싶어요!"}
                        index={3}
                        genre={"엽서/일러스트레이션 북"}
                        book={"「오늘을 견디는 한줄」, 「계절을 쓰다」"}
                        follow={"192"}
                        like={"210"}
                    />

                )}


            </div>

            <div className={"flex flex-col justify-center items-center"}>
                <Button className="border-[2px] border-main font-namsan
                         rounded-full text-main font-bold flex justify-center items-center
                          md:w-[169px]
                          h-[48px] md:h-[48px]
                          text-base md:text-sm
                          px-[43px] md:px-[32px]
                          py-4 md:py-[17px]
                          whitespace-nowrap
                          [box-shadow:0_4px_8px_0_rgba(0,128,96,0.14)]
                          "
                        onClick={() => {navigate('/author');
                        }}
                >
                    작가의 서재 둘러보기
                </Button>
            </div>
        </section>
    );
};

export default AuthorSection;
